import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTechnicalReportById } from "../../actions/VehicleReplacementsActions";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { getBatchById } from "../../actions/BatchActions";
import { getJobCardById } from "../../actions/JobCardActions";
import { ThreeDots } from "react-loader-spinner";
import SignatureCanvas from 'react-signature-canvas';

function InvoiceJobCard() {
    const dispatch = useDispatch();
    const params = useParams();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [editableJobCard, setEditableJobCard] = useState({});
    const signatureRef = useRef(null);

    useEffect(() => {
        dispatch(getJobCardById(params.job_card_id));
    }, [params.job_card_id]);

    const jobCard = useSelector(state => state?.jobCard?.jobCard);
    const loading = useSelector(state => state?.loading?.addEditLoading);
    const jobCardYear = jobCard?.created_at ? new Date(jobCard.created_at).getYear() % 100 : 0;
    const jobCardMonth = jobCard?.created_at ? new Date(jobCard.created_at).getMonth() + 1 : 0;
    const formattedJobCardId = jobCard?.job_card_id ? String(jobCard.job_card_id).padStart(6, '0') : 0;

    useEffect(() => {
        document.title = "ATA-" + jobCardYear + jobCardMonth + '-' + formattedJobCardId + " SERVICE JOB CARD";
        loadSignatureFromBase64(jobCard?.vehicle_graph?.vehicle_graph);
        setEditableJobCard(prevState => ({
            ...prevState,
            ...jobCard,
            show_spare_parts: true,
            show_repair_parts: true
        }));
    }, [jobCard]);

    const user_permissions = JSON.parse(localStorage.getItem('perm'));

    const repairDetails = editableJobCard.job_card_details && editableJobCard.job_card_details
        .filter(detail => detail.product_type === 'service');

    const repairTotal = repairDetails && repairDetails.reduce((total, detail) => total + parseFloat(detail?.price_sold * detail?.quantity), 0);

    const spareDetails = editableJobCard.job_card_details && editableJobCard.job_card_details
        .filter(detail => detail.product_type === 'goods');

    const spareTotal = spareDetails && spareDetails.reduce((total, detail) => total + parseFloat(detail?.price_sold * detail?.quantity), 0);
    const totalAmount = spareTotal + repairTotal;

    const clearCanvas = () => {
        signatureRef.current.clear(); // Clear the canvas
    };

    const loadSignatureFromBase64 = (base64String) => {
        if (signatureRef.current && base64String) {
            // Clear the current canvas before loading the new data
            signatureRef.current.clear();

            // Create an image to load base64 and adjust scaling
            const img = new Image();
            img.src = base64String;
            img.onload = () => {
                const canvas = signatureRef.current.getCanvas();
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas

                // Ensure the canvas size matches original
                canvas.width = 230;
                canvas.height = 160;

                // Draw the base64 image onto the canvas, adjusting for any offset
                ctx.drawImage(img, 0, 0, 230, 160);
            };
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'F9') {
            setModalIsOpen(true);
        } else if (event.key === 'Escape') {
            setModalIsOpen(false);
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditableJobCard(prevState => {
            const newState = { ...prevState };
            const keys = name.split('.');
            let current = newState;
            for (let i = 0; i < keys.length - 1; i++) {
                if (!current[keys[i]]) {
                    current[keys[i]] = {};
                }
                current = current[keys[i]];
            }
            current[keys[keys.length - 1]] = value;
            return { ...newState }; // Ensure a new object is returned
        });
    };

    return (
        <React.Fragment>
            <body className="bg-white w-full h-screen overflow-visible">
                <div className="intro-y w-full h-full bg-white container-fluid pt-5 position-relative">
                    <div className="text-center text-sm-start pt-5">
                        <div className=" p-3">
                            <img className="print-header mt-5 px-5" src="/images/invoice-head.jpg" width={'100%'} height={60} alt="" />
                            <div className="">
                                <h3 className="fw-bold fs-xs" style={{ float: 'left' }}>Job Id: {editableJobCard?.job_card_id}</h3>
                                <div className="text-center text-decoration-underline fw-semibold fs-xl mt-10">SERVICE JOB CARD</div>
                            </div>
                        </div>
                        {
                            loading ?
                                <ThreeDots
                                    height="80"
                                    width="80"
                                    radius="9"
                                    color="#2d3748"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                    wrapperClassName=""
                                    visible={loading}
                                /> :
                                <span>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Customer : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.customer?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Mobile : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.customer?.mobile ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Reg.Expiry : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.vehicle?.registration_expiry ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Ref : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.reference ?? '-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 ps-0">
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Model : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.vehicle?.vehicle_model?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Reg. No : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.vehicle ? editableJobCard?.estimate?.vehicle?.plate_number + ' ' + editableJobCard?.estimate?.vehicle?.vehicle_code?.name + ' ' + editableJobCard?.estimate?.vehicle?.state?.name : '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Type : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.type_id === 1 ? 'Private' :
                                                            editableJobCard?.estimate?.type_id === 2 ? 'Insurance' :
                                                                editableJobCard?.estimate?.type_id === 3 ? 'N/A' : '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Spare Wheel : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.spare_wheel == true ? 'True' : 'False'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-5 p-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">CH No. : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.vehicle?.chasis_no ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 p-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Vehicle Type : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.vehicle?.vehicle_type?.name + " : " + editableJobCard?.estimate?.vehicle?.vehicle_make?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 p-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Colour : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.vehicle?.color?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Police RPT : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.police_report?.report_no ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Location : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.police_report?.location ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Police : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.police_report?.police_station?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 ps-0">
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Report Date : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.police_report?.date ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Report Time : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.police_report?.time ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Estimate No. : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.estimate_id ?? '-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-5 p-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Contractor : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.insurance_company?.name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 p-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Note : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.note !== "" ? editableJobCard?.note : '-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-8">
                                            {
                                                editableJobCard?.job_card_details && user_permissions.some(item => item.permission_id == '10') && (
                                                    <div className="row">
                                                        {editableJobCard?.job_card_details && Object.keys(editableJobCard?.job_card_details).length > 0 && (
                                                            <>
                                                                {editableJobCard.show_repair_parts && editableJobCard.job_card_details
                                                                    .filter(detail => detail.product_type === 'service')
                                                                    .length > 0 && (
                                                                        <div className="col-md-6">
                                                                            <table className="table table-bordered border border-gray-500">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="fw-bold fs-xs bg-gray-300 p-1">Repairs</th>
                                                                                        <th className="fw-bold fs-xs bg-gray-300 p-1">Value</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {editableJobCard.job_card_details
                                                                                        .filter(detail => detail.product_type === 'service')
                                                                                        .map((detail, index) => (
                                                                                            <tr key={index}>
                                                                                                <td className="p-1 fs-xs">{detail?.product_name}</td>
                                                                                                <td className="p-1 fs-xs">{parseFloat(detail?.price_sold * detail?.quantity).toFixed(2) ?? 0}</td>
                                                                                            </tr>
                                                                                        ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}

                                                                {editableJobCard.show_spare_parts && editableJobCard.job_card_details
                                                                    .filter(detail => detail.product_type === 'goods')
                                                                    .length > 0 && (
                                                                        <div className="col-md-6">
                                                                            <table className="table table-bordered border border-gray-500">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="fw-bold fs-xs bg-gray-300 p-1">Spare Parts</th>
                                                                                        <th className="fw-bold fs-xs bg-gray-300 p-1">Value</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {editableJobCard.job_card_details
                                                                                        .filter(detail => detail.product_type === 'goods')
                                                                                        .map((detail, index) => (
                                                                                            <tr key={index}>
                                                                                                <td className="p-1 fs-xs">{detail?.product_name}</td>
                                                                                                <td className="p-1 fs-xs">{parseFloat(detail?.price_sold * detail?.quantity).toFixed(2) ?? 0}</td>
                                                                                            </tr>
                                                                                        ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}
                                                            </>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        </div>

                                        <div className="col-md-4">
                                            <div className="border border-gray-300 rounded-2 canvas-bg" style={{ width: 230, height: 160 }}>
                                                <SignatureCanvas
                                                    penColor='transparent'
                                                    ref={(ref) => (signatureRef.current = ref)}
                                                    onKeyPress={clearCanvas}
                                                    canvasProps={{ width: 230, height: 160, className: 'signatureCanvas' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                {
                                                    editableJobCard?.images && Object.keys(editableJobCard?.images).length > 0 &&
                                                    editableJobCard?.images
                                                        .filter((image) => image.type === 'jobIn')
                                                        .slice(0, 2)
                                                        .map((image, index) => {
                                                            return (
                                                                <div className="col-md-2">
                                                                    <img className=" w-24 h-20 ps-0 pt-0 pb-3" src={image.image_path + '/' + image.file_name} />
                                                                </div>
                                                            )
                                                        })
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="border border-gray-500 p-1 bg-gray-300">
                                                <h3 className="fw-bold fs-xs">Repair : {parseFloat(repairTotal).toFixed(2) ?? '0'} </h3>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Approval : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.lpo_claim ? parseFloat(editableJobCard?.lpo_claim?.lpo_value).toFixed(2) : '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Receiver : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{'-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 ps-0">
                                            <div className="border border-gray-500 p-1 bg-gray-300">
                                                <h3 className="fw-bold fs-xs">Parts : {parseFloat(spareTotal).toFixed(2) ?? '0'} </h3>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Excess : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.lpo_claim ? parseFloat(editableJobCard?.lpo_claim?.excess).toFixed(2) : '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Received AED : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{'-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 ps-0">
                                            <div className="border border-gray-500 p-1 bg-gray-300">
                                                <h3 className="fw-bold fs-xs">Total : {parseFloat(totalAmount).toFixed(2) ?? '0'} </h3>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Additional : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{'0.00'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Received At : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{'-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 px-10 py-3">
                                            <div className="container">
                                                <ul style={{ listStyle: "auto", color: '#000' }}>
                                                    <li className="fs-xs">Customers are requested not to leave an personal belonging in their cars.(e.g, gold key chain, lighters, money, cassettes
                                                        etc.) The Management declines responsibility.</li>
                                                    <li className="fs-xs">
                                                        .Delivery of cars to be taken when promised, delay from customer side shall be obliged to charge a fee of Dhs 10 per day.
                                                    </li>
                                                    <li className="fs-xs">
                                                        If the customer fails to collect his car after 7 days on completion of repair. it will be parked in the companys open car
                                                        stores and no responsibility will be accepted for any damage due to change in climate or any other cause beyond our
                                                        control.
                                                    </li>
                                                    <li className="fs-xs">.If the customer does not request for old parts at the time of repair, the companay will scrap them and the customer has
                                                        no claim thereafter</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Date In : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.date ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">In Mobile : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.customer?.mobile ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Km In : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.km_in ?? '-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4 ps-0">
                                            <div className="row">
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Advisor : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500 w-full">
                                                        {/* <h3 className="text-capitalize fs-xs">{editableJobCard?.estimate?.vehicle?.vehicle_model?.name ?? '-'}</h3> */}
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.created_by?.user_name ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 pe-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Start Date : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.start_on ?? '-'}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-5 p-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">KM Out : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.km_out ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 p-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Out Mobile : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">{editableJobCard?.out_mobile ?? '-'}</h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 p-0">
                                                    <div className="border border-gray-500 p-1 bg-gray-300 h-full">
                                                        <h3 className="fw-bold fs-xs">Date Out : </h3>
                                                    </div>
                                                </div>
                                                <div className="col-md-7 ps-0">
                                                    <div className="p-1 border border-gray-500">
                                                        <h3 className="text-capitalize fs-xs">
                                                            {editableJobCard.job_out
                                                                ? moment(editableJobCard.updated_at).format('YYYY-MM-DD HH:mm:ss')
                                                                : editableJobCard?.date_out ?? '-'}
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3 mb-10">
                                        <div className="col-md-4">
                                            <div className="border border-gray-500 p-1 bg-gray-300">
                                                <h3 className="fw-bold fs-xs">In Customer Signature : </h3>
                                            </div>
                                        </div>
                                        <div className="col-md-4 ps-0">
                                            <div className="border border-gray-500 p-1 bg-gray-300">
                                                <h3 className="fw-bold fs-xs">Pay Info : </h3>
                                            </div>
                                        </div>
                                        <div className="col-md-4 ps-0">
                                            <div className="border border-gray-500 p-1 bg-gray-300">
                                                <h3 className="fw-bold fs-xs">Out Customer Signature : </h3>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                        }
                    </div>
                    <div className="position-absolute bottom-0 w-full">
                        <img className="print-footer mb-2" src="/images/invoice-foot.jpg" width={'100%'} height={60} alt="" />
                    </div>
                </div>
            </body >

            <div className={`modal fade  ${modalIsOpen ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ display: modalIsOpen ? 'block' : 'none', border: '1px solid black' }}>
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Job Card</h5>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Customer Name:</label>
                                            <input type="text" className="form-control" name="customer.name" value={editableJobCard?.customer?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Mobile:</label>
                                            <input type="text" className="form-control" name="customer.mobile" value={editableJobCard?.customer?.mobile ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Registration Expiry:</label>
                                            <input type="date" className="form-control" name="estimate.vehicle.registration_expiry" value={editableJobCard?.estimate?.vehicle?.registration_expiry ? moment(editableJobCard.estimate.vehicle.registration_expiry).format('YYYY-MM-DD') : ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Reference:</label>
                                            <input type="text" className="form-control" name="reference" value={editableJobCard?.reference ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Model:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.vehicle_model.name" value={editableJobCard?.estimate?.vehicle?.vehicle_model?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Plate Number:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.plate_number" value={editableJobCard?.estimate?.vehicle?.plate_number ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Code:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.vehicle_code.name" value={editableJobCard?.estimate?.vehicle?.vehicle_code?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>State:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.state.name" value={editableJobCard?.estimate?.vehicle?.state?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Type:</label>
                                            <input type="text" className="form-control" name="estimate.type_id" value={editableJobCard?.estimate?.type_id === 1 ? 'Private' :
                                                editableJobCard?.estimate?.type_id === 2 ? 'Insurance' :
                                                    editableJobCard?.estimate?.type_id === 3 ? 'N/A' : ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Spare Wheel:</label>
                                            <input type="text" className="form-control" name="spare_wheel" value={editableJobCard?.spare_wheel == true ? 'True' : 'False'} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Chasis No:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.chasis_no" value={editableJobCard?.estimate?.vehicle?.chasis_no ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Type:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.vehicle_type.name" value={editableJobCard?.estimate?.vehicle?.vehicle_type?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Vehicle Make:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.vehicle_make.name" value={editableJobCard?.estimate?.vehicle?.vehicle_make?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Color:</label>
                                            <input type="text" className="form-control" name="estimate.vehicle.color.name" value={editableJobCard?.estimate?.vehicle?.color?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Police Report No:</label>
                                            <input type="text" className="form-control" name="police_report.report_no" value={editableJobCard?.police_report?.report_no ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Location:</label>
                                            <input type="text" className="form-control" name="police_report.location" value={editableJobCard?.police_report?.location ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Police Station:</label>
                                            <input type="text" className="form-control" name="police_report.police_station.name" value={editableJobCard?.police_report?.police_station?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Report Date:</label>
                                            <input type="text" className="form-control" name="police_report.date" value={editableJobCard?.police_report?.date ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Report Time:</label>
                                            <input type="text" className="form-control" name="police_report.time" value={editableJobCard?.police_report?.time ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Estimate No:</label>
                                            <input type="text" className="form-control" name="estimate.estimate_id" value={editableJobCard?.estimate?.estimate_id ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Contractor:</label>
                                            <input type="text" className="form-control" name="insurance_company.name" value={editableJobCard?.insurance_company?.name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Note:</label>
                                            <input type="text" className="form-control" name="note" value={editableJobCard?.note ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Date In:</label>
                                            <input type="text" className="form-control" name="date" value={editableJobCard?.date ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Km In:</label>
                                            <input type="text" className="form-control" name="km_in" value={editableJobCard?.km_in ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Advisor:</label>
                                            <input type="text" className="form-control" name="created_by?.user_name" value={editableJobCard?.created_by?.user_name ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Start Date:</label>
                                            <input type="text" className="form-control" name="start_on" value={editableJobCard?.start_on ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Km Out:</label>
                                            <input type="text" className="form-control" name="km_out" value={editableJobCard?.km_out ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Out Mobile:</label>
                                            <input type="text" className="form-control" name="out_mobile" value={editableJobCard?.out_mobile ?? ''} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Date Out:</label>
                                            <input type="text" className="form-control" name={editableJobCard.job_out ? 'updated_at' : 'date_out'} value={editableJobCard.job_out ? moment(editableJobCard.updated_at).format('YYYY-MM-DD HH:mm:ss') : editableJobCard?.date_out} onChange={handleInputChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Show Repair Parts:</label>
                                            <input type="checkbox" className="" name="show_repair_parts" checked={editableJobCard?.show_repair_parts ?? false} value={editableJobCard?.show_repair_parts} onChange={(e) => {
                                                handleInputChange({ target: { name: 'show_repair_parts', value: e.target.checked } });
                                            }} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label>Show Spare Parts:</label>
                                            <input type="checkbox" className="" name="show_spare_parts" checked={editableJobCard?.show_spare_parts ?? false} value={editableJobCard?.show_spare_parts} onChange={(e) => {
                                                handleInputChange({ target: { name: 'show_spare_parts', value: e.target.checked } });
                                            }} />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setModalIsOpen(false)}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}

export default InvoiceJobCard;